/* eslint-disable import/prefer-default-export */

import omit from 'lodash/omit';

function getFieldsToRemove() {
  return ['id', 'created', 'lastModified', 'createdBy', 'lastModifiedBy'];
}

export function transformForPatch(model) {
  return omit(model, getFieldsToRemove());
}
